module.exports = __webpack_public_path__ + "img/ofresh.aae1d017.png";